import _extends from "@babel/runtime-corejs3/helpers/esm/extends";
import React from "react";
import PropTypes from "prop-types";
import styles from "../../css/index.css";

const Spinner = _ref => {
  let {
    className,
    size,
    ...props
  } = _ref;
  const sizeClass = size ? styles[`size-${size}`] : styles['size-default'];
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: `${styles.loading} ${sizeClass} ${className}`,
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("circle", {
    className: styles.spinner,
    cx: "50%",
    cy: "50%",
    r: "10",
    strokeDasharray: "0",
    strokeDashoffset: "0"
  }));
};

process.env.NODE_ENV !== "production" ? Spinner.propTypes = {
  /**
   * Additional classNames the consumer can pass
   */
  className: PropTypes.string,

  /**
   * A size class to set spinner height/width.
   */
  size: PropTypes.oneOf(['sm', 'md', 'lg'])
} : void 0;
Spinner.defaultProps = {
  className: '',
  size: null
};
export default Spinner;